module.exports = __webpack_public_path__ + "static/media/error-hexagon.0456a3ef.svg";